import type { IconProps } from './IconsTypes'

export const ArrowDownFooter = ({
  width = 24,
  height = 24,
  viewBox = '0 0 24 24',
  color = '#fff',
  className,
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      className={'block ' + className}
    >
      <path
        d="M12 15.0003C11.744 15.0003 11.488 14.9023 11.293 14.7073L7.29301 10.7073C6.90201 10.3163 6.90201 9.68425 7.29301 9.29325C7.68401 8.90225 8.31607 8.90225 8.70707 9.29325L12 12.5862L15.293 9.29325C15.684 8.90225 16.3161 8.90225 16.7071 9.29325C17.0981 9.68425 17.0981 10.3163 16.7071 10.7073L12.7071 14.7073C12.5121 14.9023 12.256 15.0003 12 15.0003Z"
        fill={color}
      ></path>
    </svg>
  )
}
